var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearInputIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8ZM11.5302 5.57089C11.7256 5.37564 11.7256 5.05898 11.5303 4.86368L11.1363 4.46965C10.941 4.27435 10.6244 4.2744 10.4291 4.46975L8 6.90022L5.57089 4.46975C5.37564 4.2744 5.05898 4.27435 4.86368 4.46965L4.46965 4.86368C4.27435 5.05898 4.2744 5.37564 4.46975 5.57089L6.90022 8L4.46975 10.4291C4.2744 10.6244 4.27435 10.941 4.46965 11.1363L4.86368 11.5303C5.05898 11.7256 5.37564 11.7256 5.57089 11.5302L8 9.09978L10.4291 11.5302C10.6244 11.7256 10.941 11.7256 11.1363 11.5303L11.5303 11.1363C11.7256 10.941 11.7256 10.6244 11.5302 10.4291L9.09978 8L11.5302 5.57089Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearInputIcon);
export default __webpack_public_path__ + "static/media/clear-input-icon.4a1542461f800c7263dc63cb06d9ad5e.svg";
export { ForwardRef as ReactComponent };